(ns ui.view.survey.event
    (:require
     ["html-to-image" :as html-to-image]
     [ajax.core :as ajax]
     [app.survey.event :as survey-app]
     [app.survey.routes :as routes]
     [cljs-uuid-utils.core :as uuid]
     [clojure.edn :as edn]
     [clojure.set :as set]
     [clojure.string :as string]
     [common.currencies :as currencies]
     [common.languages :as languages]
     [common.localization :as loc]
     [common.mandatory :as mandatory]
     [common.time :as c-time]
     [common.util :as cu]
     [common.visibility :as visibility]
     [frontend.exports.exceljs.coercion :as excel-coercion]
     [frontend.exports.exceljs.sheet :as ex-sheet]
     [frontend.exports.exceljs.util :refer [col-index->char-str]]
     [frontend.exports.exceljs.workbook :as ex-workbook]
     [frontend.local-storage :as ls]
     [oops.core :as oops]
     [potpuri.core :as potpuri]
     [re-frame.core :as rf]
     [ui.fx.timeout :as timeout]
     [ui.util :as uu]
     [ui.view.survey.helpers :as survey-helpers]
     [ui.view.survey.modals.event :as modal-event]
     [ui.view.survey.modals.sub :as modal-sub]
     [ui.view.survey.sub :as sub]))

(rf/reg-event-fx
  ::init
  (fn [{db :db} [_ configuration access-to-other-surveys? hide-separator-popup?]]
    (let [multi-survey? (:multi-survey? configuration)
          survey-id (:db/id configuration)
          ts (or (get-in db [::sub/thousand-separator])
                 (ls/get ::sub/thousand-separator))
          ds (or (get-in db [::sub/decimal-separator])
                 (ls/get ::sub/decimal-separator))]
      {:db               (-> db
                             (assoc-in [::sub/access-to-other-surveys?] access-to-other-surveys?)
                             (assoc-in [::sub/configurations survey-id] configuration)
                             (assoc-in [::sub/unsaved-answer-series survey-id] {0 {}})
                             (assoc-in [::sub/selected-langs survey-id] (get configuration :selected-lang :ENG))
                             (assoc-in [::sub/form-style survey-id] (if multi-survey?
                                                                      :survey-form.style/grid
                                                                      :survey-form.style/form))
                             (assoc ::modal-sub/num-fmt-modal-open? (and (not hide-separator-popup?)
                                                                         (or (not ts)
                                                                             (not ds)
                                                                             (= ts ds)))
                                    ::modal-sub/survey-id survey-id))
       ::timeout/timeout {:id      (uuid/make-random-uuid)
                          :event   [::loading-timeout-done survey-id]
                          :wait-ms 500}})))

(rf/reg-event-fx
  ::loading-timeout-done
  (fn [{db :db} [_ survey-id]]
    {:db (assoc-in db [::sub/loading-completed? survey-id] true)}))

(rf/reg-event-db
  ::update-configuration
  (fn [db [_ configuration]]
    (let [survey-id (:db/id configuration)]
      (assoc-in db [::sub/configurations survey-id] configuration))))

(rf/reg-event-db
  ::cleanup-survey
  (fn [db [_ survey-id]]
    (-> db
        (update ::sub/configurations dissoc survey-id)
        (update ::sub/unsaved-answer-series dissoc survey-id)
        (update ::sub/saved-answer-series dissoc survey-id)
        (update ::sub/selected-langs dissoc survey-id)
        (update ::sub/form-style dissoc survey-id)
        (update ::sub/loading-completed? dissoc survey-id)
        (update ::sub/uploading? dissoc survey-id)
        (update ::sub/submitted? dissoc survey-id))))

(rf/reg-event-fx
  ::change-form-style
  (fn [{db :db} [_ survey-id style]]
    {:db (assoc-in db [::sub/form-style survey-id] style)}))

(rf/reg-event-fx
  ::on-answer-no-response
  (fn [{db :db} [_ survey-id id no-answer?]]
    {:db (-> db
             (assoc-in [::sub/unsaved-no-answers survey-id id] no-answer?))}))

(rf/reg-event-fx
  ::change-language
  (fn [{db :db} [_ survey-id lang]]
    {:db (assoc-in db [::sub/selected-langs survey-id] lang)}))

(rf/reg-event-fx
  ::set-thousand-separator
  (fn [{db :db} [_ separator]]
    (ls/set ::sub/thousand-separator separator)
    {:db (assoc-in db [::sub/thousand-separator] separator)}))

(rf/reg-event-fx
  ::set-decimal-separator
  (fn [{db :db} [_ separator]]
    (ls/set ::sub/decimal-separator separator)
    {:db (assoc-in db [::sub/decimal-separator] separator)}))

(rf/reg-event-fx
  ::on-answer-input
  (fn [{db :db} [_ survey-id answer-series question-id answer validate? _answer-label no-answer]]
    (let [valid-params? (and (number? survey-id)
                             (number? answer-series)
                             (number? question-id)
                             (not (map? answer)))]
      ;(js/console.log "A) on-answer-input : " question-id " > " answer)
      (if-not valid-params?
        (js/console.error "FATAL wrong update params " answer)
        (let [answer-series (cond (string? answer-series)
                                  (do (js/console.error "Expecting number answer series, got string")
                                      (edn/read-string answer-series))
                                  (number? answer-series)
                                  (int answer-series)
                                  :else
                                  (js/console.log "Wrong type for answer series : " answer-series " < " (type answer-series)))
              updated-db (-> db
                             (update-in [::sub/unsaved-answer-series]
                                        (fn [unsaved-series]
                                          (potpuri/deep-merge unsaved-series
                                                              {survey-id {answer-series {question-id answer}}})))
                             (update-in [::sub/show-missing? survey-id answer-series]
                                        (fn [missing-question-ids]
                                          (when (and missing-question-ids
                                                     (or (not (nil? answer))
                                                         (not no-answer)))
                                            (->> missing-question-ids
                                                 (remove #{question-id})
                                                 (vec))))))]
          (merge {:db updated-db}
                 (when validate?
                   {:fx [[:dispatch [::validate survey-id]]]})))))))

(rf/reg-event-fx
  ::on-download-file-ok
  (fn [_ [_ resp]]
    (let [url (:body resp)]
      (aset js/window.location "href" url)
      {})))

(rf/reg-event-fx
  ::on-download-file-failed
  (fn [_ [_ resp]]
    (js/console.log "Download FAILED : " resp)))

(rf/reg-event-fx
  ::download-file
  (fn [_ [_ {:keys [survey-id _survey-question-id file-id _answer-series _multi-file? _remove? _file-name] :as _args}]]
    {:http-xhrio {:method          :post
                  :uri             "/surveys/api/download-file"
                  :params          {:survey-id survey-id
                                    :file-id   file-id}
                  :timeout         30000
                  :format          (ajax/transit-request-format)
                  :response-format (ajax/transit-response-format)
                  :on-success      [::on-download-file-ok]
                  :on-failure      [::on-download-file-failed]}}))

(rf/reg-event-fx
  ::on-answer-input-file
  (fn [{db :db} [_ {:keys [survey-id survey-question-id file-id answer-series multi-file? remove? file-name] :as args}]]
    (let [valid-params? (and (number? survey-id)
                             (number? answer-series)
                             (number? survey-question-id)
                             (number? file-id))]
      (if-not valid-params?
        (js/console.error "FATAL wrong update file params " args)
        (let [updated-db (-> db
                             (update-in [::sub/my-file-ids]
                                        (fn [file-ids-set]
                                          (if remove?
                                            (set/difference (set file-ids-set)
                                                            #{file-id})
                                            (set/union (set file-ids-set)
                                                       #{file-id}))))
                             (update-in [::sub/unsaved-answer-series]
                                        (fn [unsaved-series]
                                          (potpuri/deep-merge unsaved-series
                                                              {survey-id {answer-series {survey-question-id
                                                                                         (cond (and remove?
                                                                                                    (not multi-file?))
                                                                                               nil
                                                                                               (not multi-file?)
                                                                                               file-id
                                                                                               remove?
                                                                                               (set/difference (set (or (get-in db [::sub/unsaved-answer-series
                                                                                                                                    survey-id
                                                                                                                                    answer-series
                                                                                                                                    survey-question-id])
                                                                                                                        (get-in db [::sub/saved-answer-series
                                                                                                                                    survey-id
                                                                                                                                    answer-series
                                                                                                                                    survey-question-id])))
                                                                                                               #{file-id})
                                                                                               :else
                                                                                               (set/union (set (or (get-in db [::sub/unsaved-answer-series
                                                                                                                               survey-id
                                                                                                                               answer-series
                                                                                                                               survey-question-id])
                                                                                                                   (get-in db [::sub/saved-answer-series
                                                                                                                               survey-id
                                                                                                                               answer-series
                                                                                                                               survey-question-id])))
                                                                                                          #{file-id}))}}})))
                             (update-in [::sub/survey-files survey-id]
                                        (fn [existing-files]
                                          (cond (not file-id)
                                                existing-files
                                                remove?
                                                (dissoc existing-files file-id)
                                                :else
                                                (potpuri/deep-merge existing-files
                                                                    {file-id file-name}))))
                             (update-in [::sub/show-missing? survey-id answer-series]
                                        (fn [missing-question-ids]
                                          (when (and missing-question-ids
                                                     (not (nil? file-id)))
                                            (->> missing-question-ids
                                                 (remove #{survey-question-id})
                                                 (vec))))))]
          {:db updated-db})))))

(rf/reg-event-fx
  ::re-select-survey
  (fn [{_db :db} [_]]
    {:fx [[:dispatch [::routes/navigate [:select-survey]]]
          [:dispatch [::survey-app/load-app-config false]]]}))

(rf/reg-event-fx
  ::validate
  (fn [{db :db} [_ survey-id]]
    (let [configurations (get db ::sub/configurations)
          saved-answer-series (get db ::sub/saved-answer-series)
          unsaved-answer-series (get db ::sub/unsaved-answer-series)
          survey-config (get configurations survey-id)
          all-questions (->> survey-config
                             :blocks
                             (cu/filter-by :block-type :survey-block/section)
                             (mapcat (fn [block]
                                       (->> block
                                            :content
                                            (cu/filter-by :survey-item-type :survey-item/question)))))
          survey-answer-series (potpuri/deep-merge (get-in saved-answer-series [survey-id] {})
                                                   (get-in unsaved-answer-series [survey-id] {}))
          missing-id-series (->> survey-answer-series
                                 (map (fn [[series survey-answers]]
                                        (let [visible-questions (->> all-questions
                                                                     (filter (fn [q]
                                                                               (visibility/calc-visibility survey-answers (:visibility-rules q) (:visibility q)))))
                                              visibility-lookup (->> visible-questions
                                                                     (map (fn [q]
                                                                            [(:survey-question-id q) true]))
                                                                     (into {}))
                                              mandatory-questions (->> visible-questions
                                                                       (filter (fn [q]
                                                                                 (let [visible? (get visibility-lookup (:survey-question-id q))]
                                                                                   (mandatory/calc-mandatoriness visible? survey-answers
                                                                                                                 (:mandatoriness q)
                                                                                                                 (:mandatoriness-rules q)))))
                                                                       (seq))
                                              missing-questions (->> mandatory-questions
                                                                     (filter (fn [q]
                                                                               (let [question-id (:survey-question-id q)
                                                                                     value (get survey-answers question-id)]
                                                                                 (cu/blank-value? value))))
                                                                     (seq))
                                              missing-question-ids (->> missing-questions
                                                                        (map :survey-question-id)
                                                                        (set))]
                                          [series missing-question-ids])))
                                 (into {}))]
      (merge {:db (-> db
                      (assoc-in [::sub/missing-answers survey-id] missing-id-series)
                      (update-in [::sub/validate-counter survey-id] inc))}
             {::timeout/timeout {:id      (uuid/make-random-uuid)
                                 :event   [::update-validate-counter survey-id]
                                 :wait-ms 500}}))))

(rf/reg-event-fx
  ::validate-and-submit
  (fn [{db :db} [_ survey-id]]
    (let [configurations (get db ::sub/configurations)
          saved-answer-series (get db ::sub/saved-answer-series)
          unsaved-answer-series (get db ::sub/unsaved-answer-series)
          survey-config (get configurations survey-id)
          all-questions (->> survey-config
                             :blocks
                             (cu/filter-by :block-type :survey-block/section)
                             (mapcat (fn [block]
                                       (->> block
                                            :content
                                            (cu/filter-by :survey-item-type :survey-item/question)))))
          survey-answer-series (potpuri/deep-merge (get-in saved-answer-series [survey-id] {})
                                                   (get-in unsaved-answer-series [survey-id] {}))
          missing-id-series (->> survey-answer-series
                                 (keep (fn [[series survey-answers]]
                                         (when (or (zero? series)
                                                   (and (not (get-in configurations [survey-id :time-series?]))
                                                        (get-in configurations [survey-id :multi-survey?])))
                                           (let [visible-questions (->> all-questions
                                                                        (filter (fn [q]
                                                                                  (visibility/calc-visibility survey-answers (:visibility-rules q) (:visibility q)))))
                                                 visibility-lookup (->> visible-questions
                                                                        (map (fn [q]
                                                                               [(:survey-question-id q) true]))
                                                                        (into {}))
                                                 mandatory-questions (->> visible-questions
                                                                          (filter (fn [q]
                                                                                    (let [visible? (get visibility-lookup (:survey-question-id q))]
                                                                                      (mandatory/calc-mandatoriness visible? survey-answers
                                                                                                                    (:mandatoriness q)
                                                                                                                    (:mandatoriness-rules q)))))
                                                                          (seq))
                                                 missing-questions (->> mandatory-questions
                                                                        (filter (fn [q]
                                                                                  (let [question-id (:survey-question-id q)
                                                                                        value (get survey-answers question-id)]
                                                                                    (cu/blank-value? value))))
                                                                        (seq))
                                                 missing-question-ids (->> missing-questions
                                                                           (map :survey-question-id)
                                                                           (set)
                                                                           (seq))]
                                             (js/console.log "Missing in series " missing-question-ids " << " mandatory-questions
                                                             "\n" survey-answers)
                                             (when missing-question-ids
                                               [series missing-question-ids])))))
                                 (into {}))
          no-missing? (empty? missing-id-series)]
      (js/console.log "No missing? " no-missing?)
      (merge {:db (-> db
                      (assoc-in [::sub/missing-answers survey-id] missing-id-series))}
             {:fx
              (if no-missing?
                ;[[:dispatch [::submit survey-id]]]
                [[:dispatch [::modal-event/open-submit-modal survey-id]]]
                [[:dispatch [::show-missing survey-id missing-id-series]]])}
             (when-not no-missing?
               {::timeout/timeout {:id      (uuid/make-random-uuid)
                                   :event   [::update-validate-counter survey-id]
                                   :wait-ms 500}})))))

(rf/reg-event-fx
  ::update-validate-counter
  (fn [{db :db} [_ survey-id]]
    {:db (update-in db [::sub/validate-counter survey-id] inc)}))

(rf/reg-event-fx
  ::show-missing
  (fn [{db :db} [_ survey-id missing-answers]]
    (let [survey-id (cond (number? survey-id)
                          survey-id
                          (string? survey-id)
                          (do (js/console.log "Wrong data type for show missing survey id : " survey-id)
                              (edn/read-string survey-id)))
          first-missing-q (->> missing-answers
                               (keep (fn [[series missing-answers]]
                                       (sub/dom-id survey-id series (first missing-answers))))
                               (first))]
      (try
        (js/console.log "Scroll into view : " first-missing-q)
        (.scrollIntoView (.getElementById js/document first-missing-q))
        (catch js/Object e
          (js/console.error e "Failed to scroll into view : " first-missing-q)))
      {:db (-> db
               (assoc-in [::sub/show-missing? survey-id] missing-answers)
               (assoc-in [::modal-sub/missing-modal-open?] true))})))

(rf/reg-event-fx
  ::add-answer-series
  (fn [{db :db} [_ survey-id]]
    (let [configuration (get-in db [::sub/configurations survey-id])
          questions (survey-helpers/resolve-indexed-questions configuration)
          first-question-id (->> questions
                                 (keep :survey-question-id)
                                 (first))
          saved-answer-series (get-in db [::sub/saved-answer-series survey-id])
          unsaved-answer-series (get-in db [::sub/unsaved-answer-series survey-id])
          max-saved-index (if-not (map? saved-answer-series)
                            0
                            (->> saved-answer-series
                                 (map key)
                                 (sort)
                                 (last)))
          max-unsaved-index (if-not (map? unsaved-answer-series)
                              0
                              (->> unsaved-answer-series
                                   (map key)
                                   (sort)
                                   (last)))
          new-series-index (inc (max max-saved-index max-unsaved-index))]
      {:db (-> db
               (update-in [::sub/unsaved-answer-series survey-id]
                          (fn [series]
                            (if (nil? series)
                              {new-series-index {first-question-id nil}}
                              (potpuri/deep-merge series
                                                  {new-series-index {first-question-id nil}})))))})))

(rf/reg-event-fx
  ::remove-last-answer-series
  (fn [{db :db} [_ survey-id]]
    (let [saved-answer-series (get-in db [::sub/saved-answer-series survey-id])
          unsaved-answer-series (get-in db [::sub/unsaved-answer-series survey-id])
          max-saved-index (if-not (map? saved-answer-series)
                            0
                            (->> saved-answer-series
                                 (map key)
                                 (sort)
                                 (last)))
          max-unsaved-index (if-not (map? unsaved-answer-series)
                              0
                              (->> unsaved-answer-series
                                   (map key)
                                   (sort)
                                   (last)))]
      (cond (and (< max-saved-index 1)
                 (< max-unsaved-index 1))
            (js/console.log "Cannot remove last column")
            (> max-unsaved-index max-saved-index)
            {:db (update-in db [::sub/unsaved-answer-series survey-id]
                            (fn [series]
                              (if-not (map? series)
                                series
                                (->> series
                                     (remove (fn [[k _m]]
                                               (= k max-unsaved-index)))
                                     (into {})))))}
            :else
            {:fx [[:dispatch [::modal-event/open-remove-column-modal survey-id max-saved-index]]]}))))

(defn data-type-label
  [dt]
  (case dt
    :data.type/keyword "Option"
    :data.type/ref-single "Option"
    :data.type/ref-multi "Option, multi-value"
    :data.type/text-richtext "text, optional html"
    :data.type/currency-value "Number"
    :data.type/currency-symbol "Currency code"
    :data.type/date-year "Year"
    :data.type/calculated-number "Number, calculated"
    :data.type/keyword-multi "Option, multi-value"
    :data.type/number "Number"
    (loc/tr dt)))

(defn data-type->excel-format
  [dt]
  (case dt
    :data.type/boolean "@"
    :data.type/currency-symbol "@"
    :data.type/currency-value "#,##0.00"
    :data.type/date "yyyy-mm-dd"
    :data.type/date-year "###0"
    :data.type/datetime "yyyy-mm-dd"
    :data.type/email-multi "@"
    :data.type/email "@"
    :data.type/text "@"
    :data.type/id "@"
    :data.type/integer "#,##0"
    :data.type/keyword-multi "@"
    :data.type/keyword "@"
    :data.type/long "#,##0"
    :data.type/number "#,##0.00"
    :data.type/percentage "#,##0.00%"
    :data.type/multiplier "#,##0.00x"
    :data.type/ref-multi "@"
    :data.type/ref-single "@"
    :data.type/text-edn "@"
    :data.type/financials "@"
    :data.type/tesi-financials "@"
    :data.type/tesi-financials-2 "@"
    :data.type/text-multiline "@"
    :data.type/text-multi "@"
    :data.type/url-multi "@"
    :data.type/text-richtext "@"
    :data.type/text-simple "@"
    :data.type/text-url "@"
    false))

(defn resolve-question-label
  [lang question value]
  (->> question
       :survey-question/options
       (cu/filter-by :value value)
       (keep (fn [option]
               (if-let [translations (get option :translations)]
                 (or (get translations lang)
                     (get translations (languages/long->short lang))
                     (get translations :en))
                 (let [label (get option :label)]
                   (cond (string? label)
                         label
                         (map? label)
                         (get label lang))))))
       (first)))

(defn value->excel
  [lang question value]
  (if (nil? value)
    nil
    (case (:survey-question/data-type question)
      :data.type/boolean (cond (boolean? value)
                               value
                               (string? value)
                               (edn/read-string value)
                               :else
                               (boolean value))
      :data.type/currency-symbol (currencies/get-label value)
      :data.type/currency-value value
      :data.type/date (excel-coercion/millis->excel-date value)
      :data.type/date-year value
      :data.type/datetime (excel-coercion/millis->excel-date value)
      :data.type/email-multi (string/join "; " value)
      :data.type/email value
      :data.type/text value
      :data.type/id value
      :data.type/file (if value (loc/tr :submitted) nil)
      :data.type/integer value
      :data.type/keyword-multi (->> value
                                    (map loc/tr)
                                    (string/join ";"))

      :data.type/keyword (loc/tr value)
      :data.type/long value
      :data.type/number value
      :data.type/percentage value
      :data.type/multiplier value
      :data.type/ref-multi (->> value
                                (map (fn [v]
                                       (resolve-question-label lang question v)))
                                (string/join ";"))
      :data.type/ref-single (resolve-question-label lang question value)
      :data.type/text-edn nil
      :data.type/financials nil
      :data.type/tesi-financials nil
      :data.type/tesi-financials-2 nil
      :data.type/text-multiline value
      :data.type/text-multi (string/join "; " value)
      :data.type/url-multi (string/join "; " value)
      :data.type/text-richtext value
      :data.type/text-simple value
      :data.type/text-url value
      (do
        (js/console.log "Unimplemented value->excel survey type : " question)
        nil))))

(defn operator-text
  [operator value]
  (case operator
    :operand/after (str "> " value)
    :operand/all-of (str "all of " (string/join ", " value))
    :operand/any-of (str "any of " (string/join ", " value))
    :operand/before (str "< " value)
    :operand/between-exclusive (str (first value) " < " (second value))
    :operand/between-exclusive-date (str (first value) " < " (second value))
    :operand/between-inclusive (str (first value) " =<= " (second value))
    :operand/between-inclusive-date (str (first value) " =<= " (second value))
    :operand/contains (str "contains " value)
    :operand/contains-display-string (str "contains  " value)
    :operand/contains-exactly (str "equals " value)
    :operand/does-not-contain-exactly (str "does not contain " value)
    :operand/ends-with (str "ends with " value)
    :operand/ends-with-display-string (str "ends with " value)
    :operand/equal-or-greater-than (str "=> " value)
    :operand/equal-or-smaller-than (str "<= " value)
    :operand/equals (str "= " value)
    :operand/equals-date (str "= " value)
    :operand/equals-display-string (str "= " value)
    :operand/equals-ignore-case (str "= " value)
    :operand/false "= false"
    :operand/greater-than (str "> " value)
    :operand/known "has value"
    :operand/none-of (str "none of " (string/join ", " value))
    :operand/not-equal (str "!= " value)
    :operand/on-or-after (str "=> " value)
    :operand/on-or-before (str "=> " value)
    :operand/smaller-than (str "< " value)
    :operand/starts-with (str "starts with " value)
    :operand/starts-with-display-string (str "starts with " value)
    :operand/true "= true"
    nil))

(defn optional-text-for-rule
  [question-lookup question {:keys [query-type rules operator field value] :as _rule}]
  (case query-type
    :query-type/or-collection
    (cond (zero? (count rules))
          nil
          (= 1 (count rules))
          (optional-text-for-rule question-lookup question (first rules))
          :else
          (->> rules
               (keep (partial optional-text-for-rule question-lookup question))
               (string/join " OR ")))
    :query-type/and-collection
    (cond (zero? (count rules))
          nil
          (= 1 (count rules))
          (optional-text-for-rule question-lookup question (first rules))
          :else
          (->> rules
               (keep (partial optional-text-for-rule question-lookup question))
               (string/join " AND ")))
    :query-type/single-item
    (let [target-question (get question-lookup field)]
      (when target-question
        (when-let [operator-text (operator-text operator value)]
          (str "#" (:index target-question)
               " "
               operator-text))))
    nil))

(defn optional-text
  [question-lookup question]
  (when (= (:visibility question) :visibility/conditional)
    (let [visibility-rules (:visibility-rules question)]
      (->> visibility-rules
           (keep (fn [rule]
                   (let [rule-text (optional-text-for-rule question-lookup question rule)]
                     (when-not (cu/blank-value? rule-text)
                       (str "Fill when " rule-text)))))
           (first)))))

(defn resolve-import-rows
  [lang questions]
  (let [questions-lookup (->> questions
                              (map (fn [q]
                                     [(:survey-question-id q) q]))
                              (into {}))]
    (->> questions
         (cu/remove-by :survey-question/data-type :data.type/file)
         (map (fn [question]
                {:index                (:index question)
                 :question             question
                 :label                (get-in question [:survey-question/label-translations lang])
                 :info                 (uu/html->text (get-in question [:survey-question/info-translations lang]))
                 :data-unit            (or (:survey-question/data-unit question) " ")
                 :data-type            (data-type-label (:survey-question/data-type question))
                 :optional?            (optional-text questions-lookup question)
                 :not-applicable       (or (when (get-in question [:visibility-infos :ENG])
                                             (loc/tr :conditional))
                                           (->> (get question :visibility-infos)
                                                (map (fn [{:keys [_label code] :as _info}]
                                                       (let [code (or (get code lang)
                                                                      (get code :ENG))]
                                                         code)))
                                                (string/join "; ")))
                 :not-applicable-notes (or (get-in question [:visibility-infos :ENG])
                                           (->> (get question :visibility-infos)
                                                (map (fn [{:keys [label _code] :as _info}]
                                                       (let [label (or (get label lang)
                                                                       (get label :ENG))]
                                                         label)))
                                                (string/join "\n ")))
                 :external-ids         (:survey-question/external-ids question)
                 :unique-identifier?   (:survey-question/unique-identifier? question)
                 :excel-formatting     (let [dt (data-type->excel-format (:survey-question/data-type question))]
                                         dt)
                 :excel-options        (if (= :data.type/boolean (:survey-question/data-type question))
                                         ["TRUE" "FALSE"]
                                         nil #_(case (->> question
                                                          :survey-question/options
                                                          (sort-by :common/ord)
                                                          (mapv (fn [option]
                                                                  (if-let [translations (get option :translations)]
                                                                    (or (get translations lang)
                                                                        (get translations (languages/long->short lang))
                                                                        (get translations :en))
                                                                    (let [label (get option :label)]
                                                                      (cond (string? label)
                                                                            label
                                                                            (map? label)
                                                                            (get label lang))))))
                                                          (first))
                                                 "Agriculture" ["='3 OPTIONS'!$B$2:$B$9999'"]
                                                 "Seed" ["='3 OPTIONS'!$C3$:$C9999'"]
                                                 "GHG Protocol Scopes 1&2" ["='3 OPTIONS'!$D3$:$D9999'"]
                                                 ""))})))))

(rf/reg-event-fx
  ::generate-excel
  (fn [{db :db} [_ survey-id]]
    {:db               (assoc-in db [::sub/loading-excel survey-id] (c-time/now-millis))
     ::timeout/timeout {:id      (uuid/make-random-uuid)
                        :event   [::generate-excel-info survey-id]
                        :wait-ms 100}}))

(rf/reg-event-fx
  ::generate-excel-info
  (fn [{_db :db} [_ survey-id]]
    (if-let [dom-node (js/document.getElementById (str "survey-excel-info-" survey-id))]
      (let [dom-width (oops/oget dom-node "clientWidth")
            dom-height (oops/oget dom-node "clientHeight")
            prom (oops/ocall! html-to-image "toPng" dom-node (clj->js {:cacheBust true}))]
        (-> prom
            (.then (fn [img]
                     (rf/dispatch [::download-template survey-id img {:width  dom-width
                                                                      :height dom-height}])))
            (.catch (fn [_err]
                      (rf/dispatch [::download-template survey-id nil nil])))))
      (rf/dispatch [::download-template survey-id nil nil]))
    {}))

(defn new-survey-questions->excel
  [{:keys [answer-series configuration wb]}]
  (->> configuration
       :blocks
       (cu/filter-by :block-type :survey-block/section)
       (map-indexed (fn [idx block]
                      (let [label (or (get-in block [:label :ENG])
                                      (first (get-in block [:label]))
                                      (str "Sheet" idx))
                            label (-> label
                                      (string/replace ":" "")
                                      (string/replace "?" "")
                                      (string/replace "\\" "")
                                      (string/replace "/" "")
                                      (string/replace "[" "")
                                      (string/replace "]" "")
                                      (string/replace "(" "")
                                      (string/replace ")" "")
                                      (string/replace "*" "")
                                      (string/replace "!" ""))
                            table-sheet (ex-workbook/add-sheet wb label)
                            questions (:content block)]
                        (ex-sheet/set-columns table-sheet (concat ["" ""]))
                        (ex-sheet/set-header-row-styles table-sheet 1)
                        (ex-sheet/add-rows table-sheet
                                           (->> questions
                                                (mapv (fn [{:keys [survey-question-id] :as question}]
                                                        (let [value (get-in answer-series [0 survey-question-id])
                                                              excel-label (get-in question [:survey-question/label-translations :ENG])
                                                              excel-value (value->excel :ENG question value)]
                                                          [excel-label excel-value])))
                                                (doall))))))
       (doall)))

(defn new-survey-table-blocks->excel
  [{:keys [answer-series configuration wb]}]
  (->> configuration
       :blocks
       (cu/filter-by :block-type :survey-block/table-block)
       (map-indexed (fn [idx block]
                      (let [label (or (get-in block [:label :ENG])
                                      (first (get-in block [:label]))
                                      (str "Sheet" idx))
                            label (-> label
                                      (string/replace ":" "")
                                      (string/replace "?" "")
                                      (string/replace "\\" "")
                                      (string/replace "/" "")
                                      (string/replace "[" "")
                                      (string/replace "]" "")
                                      (string/replace "(" "")
                                      (string/replace ")" "")
                                      (string/replace "*" "")
                                      (string/replace "!" ""))
                            table-sheet (ex-workbook/add-sheet wb label)
                            columns (:columns block)
                            questions (:content block)]
                        (ex-sheet/set-columns table-sheet (concat [""]
                                                                  (->> columns
                                                                       (mapv :label))))
                        (ex-sheet/set-header-row-styles table-sheet 1)
                        (ex-sheet/add-rows table-sheet
                                           (->> questions
                                                (mapv (fn [{:keys [survey-question-id] :as question}]
                                                        (uu/vec-cat [(get-in question [:survey-question/label-translations :ENG])]
                                                                    (->> (range (count columns))
                                                                         (mapv (fn [idx]
                                                                                 (let [value (get-in answer-series [idx survey-question-id])]
                                                                                   (value->excel :ENG question value))))
                                                                         (doall)))))
                                                (doall))))))
       (doall)))

(defn new-survey->excel
  [{:keys [db survey-id configuration] :as args}]
  (let [unsaved-answer-series (get-in db [::sub/unsaved-answer-series survey-id] {})
        saved-answer-series (get-in db [::sub/saved-answer-series survey-id] {})
        excel-generation-started (get-in db [::sub/loading-excel survey-id] (c-time/now-millis))
        answer-series (potpuri/deep-merge saved-answer-series
                                          unsaved-answer-series)
        wb (ex-workbook/create-workbook)
        file-name (string/replace (str (get-in configuration [:label :ENG]))
                                  #"%target%" (str (:survey-target-name configuration)))]

    (new-survey-table-blocks->excel (assoc args :wb wb
                                           :answer-series answer-series))
    (new-survey-questions->excel (assoc args :wb wb
                                        :answer-series answer-series))

    (ex-workbook/save-workbook wb file-name)
    (let [time-spent (- (c-time/now-millis) excel-generation-started)]
      (if (> time-spent 2000)
        {:db (assoc-in db [::sub/loading-excel survey-id] nil)}
        {::timeout/timeout {:id      (uuid/make-random-uuid)
                            :event   [::close-loading-excel survey-id]
                            :wait-ms (- 2000 time-spent)}}))))

(defn old-survey->excel
  [{:keys [db survey-id questions configuration _info-image-base-64 _image-size]}]
  (let [unsaved-answer-series (get-in db [::sub/unsaved-answer-series survey-id] {})
        survey-external-ids (get-in db [::sub/survey-questions-ext-ids survey-id] {})
        saved-answer-series (get-in db [::sub/saved-answer-series survey-id] {})
        lang :ENG                                           ;(get db [::sub/selected-lang survey-id] :ENG)
        excel-generation-started (get-in db [::sub/loading-excel survey-id] (c-time/now-millis))
        multi-survey? (get configuration :multi-survey?)
        answer-series (potpuri/deep-merge saved-answer-series
                                          unsaved-answer-series)
        row-configs (resolve-import-rows lang questions)
        [wb data-sheet] (ex-workbook/create-workbook-with-sheet "Data")
        column-infos (concat [{:header "#"
                               :width  4}
                              {:header "Question"
                               :width  50}
                              {:header "Info"
                               :width  50}
                              {:header "Data unit"
                               :width  12}
                              {:header "Data type"
                               :width  18}
                              {:header "ID"
                               :width  10}
                              {:header "Dont' fill if"
                               :width  20}]
                             (->> (range 0 (if multi-survey?
                                             (max (count answer-series) 50)
                                             1))
                                  (map-indexed (fn [idx _]
                                                 {:header (str "Response " (inc idx))
                                                  :width  50}))))

        file-name (string/replace (str (get-in configuration [:label :ENG]))
                                  #"%target%" (str (:survey-target-name configuration)))]

    ;; content
    (ex-sheet/set-column-infos data-sheet column-infos)
    (ex-sheet/add-rows data-sheet (->> row-configs
                                       (mapv (fn [row-config]
                                               (let [question (:question row-config)]
                                                 (vec (concat [(:index row-config)
                                                               (:label row-config)
                                                               (:info row-config)
                                                               (:data-unit row-config)
                                                               (:data-type row-config)
                                                               (sub/resolve-external-id-labels survey-external-ids (:external-ids row-config))
                                                               (:not-applicable row-config)]
                                                              (->> answer-series
                                                                   (map (fn [[_series-idx series]]
                                                                          (let [value (get series (:survey-question-id question))
                                                                                excel-value (value->excel lang question value)]
                                                                            excel-value)))))))))))
    (doseq [row-config row-configs]
      (let [na-text (:not-applicable-notes row-config)
            na-cell (oops/ocall! data-sheet "getCell" (str "G" (inc (:index row-config))))]
        (when-not (cu/blank-value? na-text)
          (oops/oset! na-cell "note" (clj->js {:texts [{:text (str na-text)}]})))))

    (ex-sheet/set-header-row-styles data-sheet 1)

    ;; options
    (ex-workbook/save-workbook wb file-name)
    (let [time-spent (- (c-time/now-millis) excel-generation-started)]
      (if (> time-spent 2000)
        {:db (assoc-in db [::sub/loading-excel survey-id] nil)}
        {::timeout/timeout {:id      (uuid/make-random-uuid)
                            :event   [::close-loading-excel survey-id]
                            :wait-ms (- 2000 time-spent)}}))))

(rf/reg-event-fx
  ::download-template
  (fn [{db :db} [_ survey-id info-image-base-64 image-size]]
    (let [configuration (get-in db [::sub/configurations survey-id])
          questions (survey-helpers/resolve-indexed-questions configuration)
          table-blocks (->> configuration
                            :blocks
                            (cu/filter-by :block-type :survey-block/table-block)
                            (seq))]
      (if (not table-blocks)
        (old-survey->excel {:db                 db
                            :survey-id          survey-id
                            :configuration      configuration
                            :questions          questions
                            :info-image-base-64 info-image-base-64
                            :image-size         image-size})
        (new-survey->excel {:db            db
                            :survey-id     survey-id
                            :configuration configuration})))))

(rf/reg-event-fx
  ::close-loading-excel
  (fn [{db :db} [_ survey-id]]
    {:db (assoc-in db [::sub/loading-excel survey-id] nil)}))

(defn resolve-question-option
  [question-config excel-value]
  (let [resolved-value (->> question-config
                            :survey-question/options
                            (keep (fn [opt]
                                    (let [match? (if-let [translations (:translations opt)]
                                                   (some #{excel-value} (->> translations
                                                                             (map val)))
                                                   (let [label (get opt :label)]
                                                     (cond (string? label)
                                                           (= label excel-value)
                                                           (map? label)
                                                           (->> label
                                                                (map val)
                                                                (some #{excel-value})))))]
                                      (when match?
                                        (:value opt)))))
                            (first))]
    [resolved-value (when-not resolved-value
                      [:cannot-resolve-option-value-from [excel-value]])]))

(defn resolve-survey-value
  [question-config _excel-value-type excel-value]
  (when (and (not (nil? excel-value))
             (not-any? #{(cu/str-trim-lcase excel-value)}
                       ["inapplicable" "not applicable"
                        "#n/a" "n/a" "na." "na" "n.a."
                        "-" "_"]))
    (let [data-type (:survey-question/data-type question-config)
          numeric-value-error-msg :cannot-resolve-numeric-value
          res (case data-type
                :data.type/boolean (cond (boolean? excel-value)
                                         [excel-value nil]
                                         (string? excel-value)
                                         (cond (some #{(cu/str-trim-lcase excel-value)} ["yes" "1" "true" "ok" "kyllä" "y" "k"])
                                               [true nil]
                                               (some #{(cu/str-trim-lcase excel-value)} ["no" "0" "false" "not" "ei" "n" "e"])
                                               [false nil]
                                               :else
                                               [nil [:cannot-resolve-boolean-value-from [excel-value]]])
                                         (number? excel-value)
                                         [(pos? excel-value) nil]
                                         :else
                                         [nil [:cannot-resolve-boolean-value-from [(str excel-value " << " (type excel-value))]]])
                :data.type/currency-symbol (resolve-question-option question-config excel-value)
                :data.type/currency-value (cond (number? excel-value)
                                                [excel-value nil]
                                                :else
                                                [nil [numeric-value-error-msg [excel-value]]])
                :data.type/date (cond (number? excel-value)
                                      [excel-value nil]
                                      (instance? js/Date excel-value)
                                      [(.getTime excel-value) nil]
                                      :else
                                      [nil [:cannot-resolve-date-value [excel-value]]])
                :data.type/datetime (cond (number? excel-value)
                                          [excel-value nil]
                                          (instance? js/Date excel-value)
                                          [(.getTime excel-value) nil]
                                          :else
                                          [nil [:cannot-resolve-date-value [excel-value]]])
                :data.type/date-year (cond (number? excel-value)
                                           [(int excel-value) nil]
                                           (string? excel-value)
                                           [(js/parseInt excel-value 10) nil]
                                           :else
                                           [nil [numeric-value-error-msg [excel-value]]])
                :data.type/email-multi [(string/split (str excel-value) ";") nil]
                :data.type/email [(if (string? excel-value)
                                    excel-value
                                    (cu/str-trim-lcase (oops/oget excel-value "text"))) nil]
                :data.type/text [(str excel-value) nil]
                :data.type/id (cond (number? excel-value)
                                    [(int excel-value) nil]
                                    :else
                                    [nil [numeric-value-error-msg [excel-value]]])
                :data.type/integer (cond (number? excel-value)
                                         [(int excel-value) nil]
                                         :else
                                         [nil [numeric-value-error-msg [excel-value]]])
                :data.type/keyword-multi (let [options (->> (string/split excel-value ";")
                                                            (map (partial resolve-question-option question-config)))
                                               errors (->> options
                                                           (filter second)
                                                           (seq))]
                                           (cond (empty? options)
                                                 [nil nil]
                                                 (empty? errors)
                                                 [(->> options
                                                       (map first)) nil]
                                                 :else
                                                 [nil [:cannot-resolve-option-value-from
                                                       [(string/join ", " (map second errors))]]]))
                :data.type/keyword (resolve-question-option question-config excel-value)
                :data.type/long (cond (number? excel-value)
                                      [(long excel-value) nil]
                                      :else
                                      [nil [numeric-value-error-msg [excel-value]]])
                :data.type/number (cond (number? excel-value)
                                        [excel-value nil]
                                        :else
                                        [nil [numeric-value-error-msg [excel-value]]])
                :data.type/percentage (cond (number? excel-value)
                                            [excel-value nil]
                                            :else
                                            [nil [numeric-value-error-msg [excel-value]]])
                :data.type/multiplier (cond (number? excel-value)
                                            [excel-value nil]
                                            :else
                                            [nil [numeric-value-error-msg [excel-value]]])
                :data.type/ref-multi (let [options (->> (string/split excel-value ";")
                                                        (map (partial resolve-question-option question-config)))
                                           errors (->> options
                                                       (filter second)
                                                       (seq))]
                                       (cond (empty? options)
                                             [nil nil]
                                             (empty? errors)
                                             [(->> options
                                                   (map first)) nil]
                                             :else
                                             [nil [:cannot-resolve-option-value-from
                                                   [(string/join ", " (map second errors))]]]))
                :data.type/ref-single (resolve-question-option question-config excel-value)
                :data.type/text-edn [nil nil]
                :data.type/financials [nil nil]
                :data.type/tesi-financials [nil nil]
                :data.type/tesi-financials-2 [nil nil]
                :data.type/text-multiline [(string/trim excel-value) nil]
                :data.type/text-multi [(string/split excel-value ";") nil]
                :data.type/url-multi [(string/split excel-value ";") nil]
                :data.type/text-richtext [(str excel-value) nil]
                :data.type/text-simple [(str excel-value) nil]
                :data.type/text-url [(if (string? excel-value)
                                       excel-value
                                       (cu/str-trim-lcase (oops/oget excel-value "hyperlink"))) nil]
                [nil [:cannot-resolve-data-type [data-type]]])]
      res)))

(def FIRST_CONTENT_ROW_TESI_SPECIFIC 7)
(def FIRST_CONTENT_COL_TESI_SPECIFIC 4)

(def FIRST_CONTENT_ROW_INVEST_EUROPE_SPECIFIC 12)
(def FIRST_CONTENT_COL_INVEST_EUROPE_SPECIFIC 4)

(def FIRST_CONTENT_ROW 1)
(def FIRST_CONTENT_COL 6)

(defn get-unique-identifier-row
  [sheet-data first-content-row row-configs external-ids]
  (->> sheet-data
       (drop first-content-row)
       (remove empty?)
       (some (fn [row]
               (let [ext-id-cell (first row)
                     excel-ext-id-value (oops/oget ext-id-cell "value")
                     unique-identifier-question-config
                     (->> row-configs
                          (filter (fn [q]
                                    (let [ext-id-refs (:external-ids q)
                                          question-ext-ids (->> ext-id-refs
                                                                (mapv #(get external-ids (:db/id %))))
                                          ext-id-strs (map str (mapv second question-ext-ids))]
                                      (and (:unique-identifier? q)
                                           (some #{(str excel-ext-id-value)} ext-id-strs)))))
                          (first))]
                 (when unique-identifier-question-config
                   row))))))

(defn get-company-name-row-values
  [sheet-data first-content-row first-content-col]
  (->> sheet-data
       (drop first-content-row)
       (first)
       (drop first-content-col)
       (map (fn [cell]
              (let [value (oops/oget cell "value")
                    value (js->clj value :keywordize-keys true)]
                (if (contains? value :formula)
                  (:result value)
                  value))))))

(defn get-unique-id-values-in-order
  [unique-id-row first-content-col]
  (->> unique-id-row
       (drop first-content-col)
       (map (fn [cell]
              (let [value (oops/oget cell "value")
                    value (js->clj value :keywordize-keys true)]
                (if (contains? value :formula)
                  (:result value)
                  value))))))

(defn parse-sheet-data-tesi
  [{:keys [sheet-data first-content-row first-content-col
           row-configs external-ids column-count errors]}]
  (->> sheet-data
       (drop first-content-row)
       (remove empty?)
       (map-indexed
         (fn [row-idx row]
           (let [ext-id-cell (first row)
                 excel-ext-id-value (oops/oget ext-id-cell "value")
                 referred-question-config (->> row-configs
                                               (filter (fn [question]
                                                         (let [ext-id-refs (:external-ids question)
                                                               external-id-tuples external-ids
                                                               question-ext-ids (->> ext-id-refs
                                                                                     (mapv (fn [id]
                                                                                             (get external-id-tuples (:db/id id)))))
                                                               ext-id-value-list (->> (mapv second question-ext-ids)
                                                                                      (remove cu/blank-value?)
                                                                                      (map str))]
                                                           (some #{(str excel-ext-id-value)} ext-id-value-list))))
                                               (first))
                 question-id (:survey-question-id (:question referred-question-config))
                 question-data-type (:survey-question/data-type (:question referred-question-config))
                 question-index (:index referred-question-config)
                 question-is-unique-identifier? (:unique-identifier? referred-question-config)
                 row-content-cells (drop first-content-col row)
                 row-values (when (seq referred-question-config)
                              (->> row-content-cells
                                   (take column-count)
                                   (map-indexed (fn [_col-idx cell]
                                                  (let [excel-value-type (oops/oget cell "type")
                                                        excel-value-js (oops/oget cell "value")
                                                        excel-value (js->clj excel-value-js :keywordize-keys true)
                                                        excel-value (if (contains? excel-value :formula)
                                                                      (:result excel-value)
                                                                      excel-value)
                                                        [value error] (when (seq referred-question-config)
                                                                        (resolve-survey-value (:question referred-question-config) excel-value-type excel-value))
                                                        cell-id (oops/oget cell "_address")]
                                                    (when error
                                                      (let [error-text (loc/tr (first error) (second error))]
                                                        (swap! errors assoc cell-id error-text)))
                                                    (merge {:resolved-value       value
                                                            :original-value       excel-value
                                                            :question-index       question-index
                                                            :question-external-id excel-ext-id-value
                                                            :cell-id              cell-id
                                                            :data-type            question-data-type}
                                                           (when (= row-idx 0)
                                                             {:pinned-row? true})
                                                           (when error
                                                             {:error error})
                                                           (when question-is-unique-identifier?
                                                             {:unique-identifier? true})))))
                                   (vec)))]

             (when (seq referred-question-config)
               [question-id row-values]))))
       (into {})))

(defn parse-wb-data-tesi
  [row-configs external-ids data errors]
  (let [parsed-data (->> data
                         (vals)
                         (map-indexed (fn [sheet-idx sheet-data]
                                        (let [sheet-name (nth (keys data) sheet-idx)
                                              first-content-row (if (= sheet-name "FILL THIS Invest Europe")
                                                                  FIRST_CONTENT_ROW_INVEST_EUROPE_SPECIFIC
                                                                  FIRST_CONTENT_ROW_TESI_SPECIFIC)
                                              first-content-col (if (= sheet-name "FILL THIS Invest Europe")
                                                                  FIRST_CONTENT_COL_INVEST_EUROPE_SPECIFIC
                                                                  FIRST_CONTENT_COL_TESI_SPECIFIC)
                                              current-uid-row (get-unique-identifier-row sheet-data
                                                                                         first-content-row
                                                                                         row-configs
                                                                                         external-ids)
                                              current-uid-values (get-unique-id-values-in-order current-uid-row
                                                                                                first-content-col)
                                              uid-col-count (->> current-uid-values
                                                                 (reverse)
                                                                 (drop-while (fn [cell]
                                                                               (cu/blank-value? cell)))
                                                                 (count))
                                              company-name-row-values (get-company-name-row-values sheet-data first-content-row first-content-col)
                                              company-name-col-count (->> company-name-row-values
                                                                          (reverse)
                                                                          (drop-while (fn [cell]
                                                                                        (cu/blank-value? cell)))
                                                                          (count))
                                              column-count (max company-name-col-count
                                                                uid-col-count)]
                                          (assoc {} sheet-name (parse-sheet-data-tesi
                                                                 {:sheet-data        sheet-data
                                                                  :first-content-row first-content-row
                                                                  :first-content-col first-content-col
                                                                  :row-configs       row-configs
                                                                  :external-ids      external-ids
                                                                  :column-count      column-count
                                                                  :errors            errors})))))
                         (into {}))]
    parsed-data))

(defn parse-wb-data
  [row-configs data-cells errors]
  (let [last-value-col (->> data-cells
                            (drop FIRST_CONTENT_ROW)
                            (map (fn [row]
                                   (->> row
                                        (reverse)
                                        (drop-while (fn [cell]
                                                      (cu/blank-value? (oops/oget cell "value"))))
                                        (count))))
                            (apply max))
        content-count (- last-value-col FIRST_CONTENT_COL)]
    (->> data-cells
         (drop FIRST_CONTENT_ROW)
         (map-indexed (fn [row-idx row]
                        (when (< row-idx (count row-configs))
                          (let [question-config (nth row-configs row-idx)
                                parsed-cells (->> row
                                                  (drop FIRST_CONTENT_COL)
                                                  (take content-count)
                                                  (mapv (fn [cell]
                                                          (let [excel-value-type (oops/oget cell "type")
                                                                excel-value (oops/oget cell "value")
                                                                [value error] (resolve-survey-value question-config excel-value-type excel-value)
                                                                cell-id (oops/oget cell "_address")
                                                                cell-style-js (oops/oget cell "style")
                                                                cell-style (js->clj cell-style-js :keywordize-keys true)
                                                                new-style (merge cell-style
                                                                                 {:fill {:type    "pattern"
                                                                                         :pattern "solid"
                                                                                         :fgColor {:argb
                                                                                                   (let [err-kw (first error)
                                                                                                         err-color (case err-kw
                                                                                                                     :cannot-resolve-data-type "75D6CE"
                                                                                                                     :cannot-resolve-date-value "EAB818"
                                                                                                                     :cannot-resolve-boolean-value-from "AAAAAA"
                                                                                                                     :cannot-resolve-numeric-value "ECA890"
                                                                                                                     :cannot-resolve-option-value-from "C8432A"
                                                                                                                     :cannot-resolve-keyword "F7941D"
                                                                                                                     "CCCCCC")]
                                                                                                     err-color)}}})]
                                                            (when error
                                                              (let [error-text (loc/tr (first error) (second error))
                                                                    error-text-excel (loc/tr (keyword (str (name (first error)) "-excel")) (second error))]
                                                                (swap! errors assoc cell-id error-text)
                                                                (oops/oset! cell "style" (clj->js new-style))
                                                                (oops/oset! cell "note" (clj->js {:texts [{:text error-text-excel}]}))))
                                                            value))))]
                            (take content-count (concat parsed-cells (repeat nil)))))))
         (keep identity)
         (vec))))

(defn check-duplicate-uids!
  [{:keys [sheet-name validation-errors unique-identifier-label]}
   valid-cols
   unique-identifier-by-col]
  (let [uid->cols (->> valid-cols
                       (map (fn [col-idx]
                              [(get unique-identifier-by-col col-idx) col-idx]))
                       (remove (fn [[uid _]] (cu/blank-value? uid)))
                       (group-by first)
                       (into {}))
        duplicates (->> uid->cols
                        (map (fn [[uid pairs]]
                               [uid (map second pairs)]))
                        (into {})
                        (filter (fn [[_ col-indices]] (> (count col-indices) 1))))]

    (doseq [[uid col-indices] duplicates]
      (let [col-labels (->> col-indices
                            (map (fn [col-idx]
                                   (col-index->char-str ""
                                                        (+ (if (= sheet-name "FILL THIS Invest Europe")
                                                             FIRST_CONTENT_COL_INVEST_EUROPE_SPECIFIC
                                                             FIRST_CONTENT_COL_TESI_SPECIFIC)
                                                           (inc col-idx))))))]
        (swap! validation-errors update-in [sheet-name :duplicate-error]
               (fn [error-list]
                 (conj (vec error-list) (str "Duplicate " unique-identifier-label " '" uid
                                             "' found in columns: "
                                             (string/join ", " col-labels)))))))))

(defn validate-sheet-columns
  [{:keys [parsed-sheet sheet-name validation-errors unique-identifier-label]}]
  (let [company-count (-> parsed-sheet vals first count)
        unique-identifier-values (->> parsed-sheet
                                      (vals)
                                      (some (fn [answers]
                                              (when (some #(true? (:unique-identifier? %)) answers)
                                                (map :original-value answers))))
                                      (vec))
        unique-identifier-by-col (zipmap (range company-count) unique-identifier-values)
        valid-cols
        (->> (range company-count)
             (filter (fn [col-idx]
                       (let [has-data? (->> parsed-sheet
                                            (map (fn [[_ answers]]
                                                   (nth answers col-idx nil)))
                                            (remove nil?)
                                            (some (fn [answer]
                                                    (not (cu/blank-value? (:original-value answer))))))
                             company-name (->> parsed-sheet
                                               (vals)
                                               (filter (fn [answers]
                                                         (every? :pinned-row? answers)))
                                               (map (fn [answers]
                                                      (:original-value (nth answers col-idx nil))))
                                               (first))
                             unique-identifier-present? (not (cu/blank-value? (get unique-identifier-by-col col-idx)))
                             excel-column (col-index->char-str "" (+ (if (= sheet-name "FILL THIS Invest Europe")
                                                                       FIRST_CONTENT_COL_INVEST_EUROPE_SPECIFIC
                                                                       FIRST_CONTENT_COL_TESI_SPECIFIC)
                                                                     (inc col-idx)))]
                         (cond
                           (and has-data? (not unique-identifier-present?))
                           (do (swap! validation-errors update-in [sheet-name :missing-error]
                                      (fn [error-list]
                                        (conj (vec error-list)
                                              (str "Missing " unique-identifier-label " for " company-name
                                                   " in column "
                                                   excel-column))))
                               false)
                           (not has-data?)
                           false
                           :else true)))))
        ordered-uids (map unique-identifier-by-col valid-cols)]
    (check-duplicate-uids!
      {:sheet-name              sheet-name
       :validation-errors       validation-errors
       :unique-identifier-label unique-identifier-label}
      valid-cols
      unique-identifier-by-col)
    ordered-uids))

(defn map-new-data-by-unique-identifier
  [{:keys [data question-ids unique-identifiers populating-data?]}]
  (let [transposed-data (->> (cu/transpose (mapv data question-ids))
                             (remove (fn [answer-vec]
                                       (every? nil? (map :original-value answer-vec)))))]
    (->> transposed-data
         (map vector unique-identifiers)
         (map
           (fn [[identifier column]]
             [identifier (->> column
                              (map vector question-ids)
                              (map (fn [[q e]]
                                     [q (if populating-data?
                                          (:resolved-value e)
                                          e)]))
                              (into {}))]))
         (into {}))))

(defn map-merged-data-to-qids
  [mapped-data question-ids unique-identifiers]
  (let [rows (->> unique-identifiers
                  (mapv (fn [uid]
                          (->> question-ids
                               (mapv (fn [qid]
                                       (get-in mapped-data
                                               [uid qid]
                                               {:resolved-value nil
                                                :original-value nil
                                                :cell-id        (str uid "-" qid)})))))))
        columns (cu/transpose rows)]
    (zipmap question-ids columns)))

(defn import-wb-loaded-tesi
  [row-configs selected-sheets external-ids wb errors on-error]
  (let [sheets (->> selected-sheets
                    (mapv (fn [sheet]
                            (if (= sheet "FILL THIS Invest Europe")
                              (ex-workbook/get-sheet wb "FILL THIS Invest Europe")
                              (or (ex-workbook/get-sheet wb "FILL THIS Tesi specific")
                                  (ex-workbook/get-sheet wb "FILL THIS FVCA & Tesi specific"))))))
        data (atom {})
        validation-errors (atom (sorted-map))]
    (->> sheets
         (map-indexed (fn [sheet-idx sheet]
                        (let [sheet-name (nth selected-sheets sheet-idx)]
                          (swap! data assoc (nth selected-sheets sheet-idx) [])
                          (oops/ocall! sheet "eachRow" (clj->js {:includeEmpty true})
                                       (fn [row row-number]
                                         (swap! data assoc-in [sheet-name (dec row-number)] [])
                                         (oops/ocall! row "eachCell" (clj->js {:includeEmpty true})
                                                      (fn [cell col-number]
                                                        (swap! data assoc-in [sheet-name (dec row-number) (dec col-number)] cell))))))))
         (doall))
    (let [res (parse-wb-data-tesi row-configs external-ids @data errors)
          invest-europe-parsed-values (get res "FILL THIS Invest Europe")
          invest-europe-qids (keys invest-europe-parsed-values)
          tesi-parsed-values (get res "FILL THIS Tesi specific")
          tesi-qids (keys tesi-parsed-values)
          unique-identifier-label (->> row-configs
                                       (filter :unique-identifier?)
                                       (first)
                                       :label)
          ie-ordered-unique-identifiers (validate-sheet-columns {:parsed-sheet            invest-europe-parsed-values
                                                                 :sheet-name              "FILL THIS Invest Europe"
                                                                 :validation-errors       validation-errors
                                                                 :unique-identifier-label unique-identifier-label})
          tesi-ordered-unique-identifiers (validate-sheet-columns {:parsed-sheet            tesi-parsed-values
                                                                   :sheet-name              "FILL THIS Tesi specific"
                                                                   :validation-errors       validation-errors
                                                                   :unique-identifier-label unique-identifier-label})
          ordered-uids (vec (set (concat ie-ordered-unique-identifiers tesi-ordered-unique-identifiers)))
          question-ids (distinct (into invest-europe-qids
                                       tesi-qids))
          unique-identifiers->ie-data (map-new-data-by-unique-identifier {:data               invest-europe-parsed-values
                                                                          :question-ids       invest-europe-qids
                                                                          :unique-identifiers ie-ordered-unique-identifiers
                                                                          :populating-data?   false})
          unique-identifiers->tesi-data (map-new-data-by-unique-identifier {:data               tesi-parsed-values
                                                                            :question-ids       tesi-qids
                                                                            :unique-identifiers tesi-ordered-unique-identifiers
                                                                            :populating-data?   false})
          merged-data (potpuri/deep-merge :replace unique-identifiers->tesi-data unique-identifiers->ie-data)
          final-data (map-merged-data-to-qids merged-data question-ids ordered-uids)]
      (if (empty? @validation-errors)
        final-data
        (on-error @validation-errors)))))

(defn import-wb-loaded
  [row-configs wb errors]
  (let [sheet (ex-workbook/get-sheet wb "Data")
        data (atom [])]
    (oops/ocall! sheet "eachRow" (clj->js {:includeEmpty true})
                 (fn [row row-number]
                   (swap! data assoc (dec row-number) [])
                   (oops/ocall! row "eachCell" (clj->js {:includeEmpty true})
                                (fn [cell col-number]
                                  (swap! data assoc-in [(dec row-number) (dec col-number)] cell)))))
    (let [res (parse-wb-data row-configs @data errors)]
      (->> res
           (cu/transpose)
           (map-indexed (fn [idx company-data]
                          [idx (->> row-configs
                                    (map-indexed (fn [idx row-config]
                                                   [(get-in row-config [:question :survey-question-id]) (nth company-data idx)]))
                                    (into {}))]))
           (into {})))))

(defn extract-excel-data-tesi
  [{:keys [file row-configs selected-sheets external-ids]} on-success on-error]
  (let [wb (ex-workbook/create-workbook)
        xlsx (aget wb "xlsx")
        load-promise (oops/ocall! xlsx "load" file)
        errors (atom {})]
    (->
      load-promise
      (.then (partial import-wb-loaded-tesi row-configs selected-sheets external-ids wb errors on-error))
      (.then (fn [res]
               (let [parse-errors @errors]
                 (on-success res parse-errors))))
      (.catch
        (fn [_e]
          (on-error :data-import-error-unknown-error))))))

(defn extract-excel-data
  [{:keys [file row-configs]} on-success on-error]
  (let [wb (ex-workbook/create-workbook)
        xlsx (aget wb "xlsx")
        load-promise (oops/ocall! xlsx "load" file)
        errors (atom {})]
    (->
      load-promise
      (.then (partial import-wb-loaded row-configs wb errors))
      (.then (fn [res]
               (let [parse-errors @errors]
                 (on-success res (when parse-errors wb) parse-errors))))
      (.catch
        (fn [_e]
          (on-error :data-import-error-unknown-error))))))

(defn index-of-cell-id
  [v target-id]
  (some (fn [[idx m]]
          (when (= (:cell-id m) target-id)
            idx))
        (map-indexed vector v)))

(rf/reg-event-fx
  ::on-error-resolve-input
  (fn [{db :db} [_ survey-id value question-id cell-id]]
    (let [parsed-data (get-in db [::sub/unconfirmed-parsed-data])
          row-values (get-in parsed-data [survey-id question-id])
          col-idx (index-of-cell-id row-values cell-id)
          original-error (get-in db [::sub/unconfirmed-parsed-data survey-id question-id col-idx :error])]
      {:db (cond-> db
                   true (assoc-in [::sub/unconfirmed-parsed-data survey-id question-id col-idx :resolved-value] value)
                   original-error (assoc-in [::sub/unconfirmed-parsed-data survey-id question-id col-idx :error]
                                            [:resolved [nil]]))})))

(rf/reg-event-fx
  ::clear-all-cells-with-errors
  (fn [{db :db} [_ survey-id parsed-data]]
    (let [data-without-errors (->> parsed-data
                                   (map (fn [[qid answers]]
                                          [qid (->> answers
                                                    (map (fn [cell]
                                                           (if (and (:error cell)
                                                                    (not= (:error cell) [:resolved [nil]]))
                                                             (assoc cell :error [:resolved [nil]])
                                                             cell)))
                                                    vec)]))
                                   (into {}))]
      {:db (-> db
               (assoc-in [::sub/unconfirmed-parsed-data survey-id] data-without-errors))})))

(rf/reg-event-fx
  ::refresh-resolved-errors
  (fn [{db :db} [_ survey-id parsed-data]]
    (let [data-without-errors (->> parsed-data
                                   (map (fn [[qid answers]]
                                          [qid (->> answers
                                                    (map (fn [cell]
                                                           (if (and (:error cell)
                                                                    (= (:error cell) [:resolved [nil]]))
                                                             (dissoc cell :error)
                                                             cell)))
                                                    vec)]))
                                   (into {}))]
      {:db (-> db
               (assoc-in [::sub/unconfirmed-parsed-data survey-id] data-without-errors))})))

(rf/reg-event-fx
  ::start-error-cell-edit
  (fn [{db :db} [_ survey-id cell-id]]
    {:db (-> db
             (assoc-in [::sub/editing-error-cell? survey-id cell-id] true))}))

(rf/reg-event-fx
  ::end-error-cell-edit
  (fn [{db :db} [_ survey-id cell-id question-id]]
    (let [parsed-data (get-in db [::sub/unconfirmed-parsed-data])
          row-values (get-in parsed-data [survey-id question-id])
          col-idx (index-of-cell-id row-values cell-id)]
      {:db (-> db
               (assoc-in [::sub/editing-error-cell? survey-id cell-id] false)
               (assoc-in [::sub/unconfirmed-parsed-data survey-id question-id col-idx :error]
                         [:resolved [nil]]))})))

(rf/reg-event-fx
  ::confirm-import-data
  (fn [{db :db} [_ survey-id checked?]]
    {:db (-> db
             (assoc-in [::sub/import-data-confirmed? survey-id] checked?))}))

(rf/reg-event-fx
  ::confirm-sheet-selection
  (fn [{db :db} [_ survey-id checked?]]
    {:db (-> db
             (assoc-in [::sub/sheet-selection-confirmed? survey-id] checked?))}))

(rf/reg-event-fx
  ::submit-tesi-esg-survey-data
  (fn [{db :db} [_ survey-id confirmed-data]]
    (let [unsaved-answer-series (get-in db [::sub/unsaved-answer-series survey-id])
          no-unsaved-answers? (->> unsaved-answer-series
                                   (remove (fn [[_k answers]]
                                             (empty? answers)))
                                   (empty?))]
      {:db (-> db
               (assoc-in [::sub/uploading? survey-id] false)
               (assoc-in [::sub/resolving-errors? survey-id] false)
               (assoc-in [::sub/import-data-confirmed? survey-id] false))
       :fx (if no-unsaved-answers?
             [[:dispatch [::populate-tesi-esg-survey-data survey-id confirmed-data]]]
             [[:dispatch [::open-overwrite-warning-modal survey-id]]])})))

(rf/reg-event-fx
  ::submit-confirm-overwrite
  (fn [{db :db} [_ survey-id confirmed-data]]
    {:db (-> db
             (assoc-in [::sub/uploading? survey-id] true)
             (assoc-in [::sub/resolving-errors? survey-id] false)
             (assoc-in [::sub/import-data-confirmed? survey-id] false))
     :fx [[:dispatch [::populate-tesi-esg-survey-data survey-id confirmed-data]]]}))

(defn get-unique-identifier-question-id
  [data]
  (->> data
       (filter (fn [[_q answers]]
                 (some :unique-identifier? answers)))
       (ffirst)))

(defn get-unique-identifiers-from-new-data
  [data]
  (->> (vals data)
       (filter (fn [val]
                 (contains? (first val) :unique-identifier?)))
       (first)
       (map :resolved-value)))

(defn get-unique-identifiers-from-old-data
  [old-data unique-id-qid]
  (->> old-data
       (sort-by key)
       (map (fn [[_ column]]
              (get column unique-id-qid)))))

(defn map-old-data-by-unique-identifier
  [data unique-identifiers]
  (->> data
       (sort-by key)
       (vals)
       (map vector unique-identifiers)
       (into {})))

(defn all-answers-empty? [answers]
  (->> answers
       (vals)
       (every? (fn [respondent-answers]
                 (->> respondent-answers
                      (vals)
                      (every? cu/blank-value?))))))

(rf/reg-event-fx
  ::populate-tesi-esg-survey-data
  (fn [{db :db} [_ survey-id confirmed-data]]
    (let [new-question-ids (keys confirmed-data)
          configuration (get-in db [::sub/configurations survey-id])
          multi-survey? (:multi-survey? configuration)
          unsaved-answer-series (get-in db [::sub/unsaved-answer-series survey-id])
          no-unsaved-answers? (->> unsaved-answer-series
                                   (remove (fn [[_k answers]]
                                             (empty? answers)))
                                   (empty?))
          unique-identifier-question-id (get-unique-identifier-question-id confirmed-data)
          new-data-unique-identifiers (get-unique-identifiers-from-new-data confirmed-data)
          old-data-unique-identifiers (get-unique-identifiers-from-old-data unsaved-answer-series unique-identifier-question-id)
          new-answers (map-new-data-by-unique-identifier {:data               confirmed-data
                                                          :question-ids       new-question-ids
                                                          :unique-identifiers new-data-unique-identifiers
                                                          :populating-data?   true})
          old-answers (map-old-data-by-unique-identifier unsaved-answer-series old-data-unique-identifiers)
          new-answers-by-col-idx (->> new-answers
                                      (vals)
                                      (map-indexed (fn [idx val-map]
                                                     [idx val-map]))
                                      (into {}))
          updated-answer-series (cond (all-answers-empty? new-answers)
                                      unsaved-answer-series
                                      (and (not multi-survey?)
                                           (not= (first new-data-unique-identifiers)
                                                 (first old-data-unique-identifiers)))
                                      (potpuri/deep-merge unsaved-answer-series new-answers-by-col-idx)
                                      :else
                                      (->> (potpuri/deep-merge (when-not no-unsaved-answers?
                                                                 old-answers)
                                                               new-answers)
                                           (vals)
                                           (map-indexed (fn [idx val-map]
                                                          [idx val-map]))
                                           (into {})))]
      {:db (-> db
               (assoc-in [::sub/overwrite-answers-modal-open? survey-id] false)
               (assoc-in [::sub/unsaved-answer-series survey-id] updated-answer-series)
               (assoc-in [::sub/resolving-errors? survey-id] false))
       :fx [[:dispatch [::cleanup]]]})))

(rf/reg-event-fx
  ::open-overwrite-warning-modal
  (fn [{db :db} [_ survey-id]]
    {:db (-> db
             (assoc-in [::sub/overwrite-answers-modal-open? survey-id] true))}))

(rf/reg-event-fx
  ::close-overwrite-warning-modal
  (fn [{db :db} [_ survey-id parsing-error?]]
    (merge
      {:db (-> db
               (assoc-in [::sub/overwrite-answers-modal-open? survey-id] false)
               (assoc-in [::sub/resolving-errors? survey-id] parsing-error?))}
      (when-not parsing-error?
        {:fx [[:dispatch [::cleanup]]]}))))

(rf/reg-event-fx
  ::close-resolving-errors-modal
  (fn [{db :db} [_ survey-id]]
    {:db (assoc-in db [::sub/resolving-errors? survey-id] false)
     :fx [[:dispatch [::cleanup]]]}))

(rf/reg-event-fx
  ::close-selecting-sheets-modal
  (fn [{db :db} [_ survey-id]]
    {:db (-> db
             (assoc-in [::sub/selecting-sheets? survey-id] false)
             (assoc-in [::sub/import-data-confirmed? survey-id] false))
     :fx [[:dispatch [::cleanup]]]}))

(rf/reg-event-fx
  ::parse-ok-tesi
  (fn [{db :db} [_ survey-id parsed-data parse-errors]]
    (let [errors-to-resolve? (boolean (seq parse-errors))]
      {:db (-> db
               (assoc-in [::sub/resolving-errors? survey-id] errors-to-resolve?)
               (assoc-in [::sub/uploading? survey-id] false)
               (assoc-in [::sub/unconfirmed-parsed-data survey-id] parsed-data)
               (assoc-in [::sub/parsing-error? survey-id] errors-to-resolve?)
               (assoc ::modal-sub/show-resolve-errors-warning? errors-to-resolve?)
               (assoc ::modal-sub/show-columns-without-errors? true))
       :fx (when-not errors-to-resolve?
             [[:dispatch [::submit-tesi-esg-survey-data survey-id parsed-data]]])})))

(rf/reg-event-fx
  ::parse-failed-tesi
  (fn [{db :db} [_ survey-id error-reason]]
    (js/console.log "Parse failed " error-reason)
    {:db (-> db
             (assoc-in [::sub/tesi-custom-excel-import-failed? survey-id] true)
             (assoc-in [::sub/data-import-error survey-id] error-reason))
     :fx [[:dispatch [::cleanup]]]}))

(rf/reg-event-fx
  ::extract-data-tesi
  (fn [{db :db} [_ survey-id import-file selected-sheets]]
    (let [lang (get db [::sub/selected-lang] :ENG)
          configuration (get-in db [::sub/configurations survey-id])
          questions (survey-helpers/resolve-indexed-questions configuration)
          questions-external-ids (get-in db [::sub/survey-questions-ext-ids survey-id])
          row-configs (resolve-import-rows lang questions)]
      (extract-excel-data-tesi
        {:file            import-file
         :row-configs     row-configs
         :selected-sheets selected-sheets
         :external-ids    questions-external-ids}
        (fn [parsed-data parse-errors]
          (rf/dispatch [::parse-ok-tesi survey-id parsed-data parse-errors]))
        (fn [error-reason]
          (rf/dispatch [::parse-failed-tesi survey-id error-reason])))
      {})))

(defn extract-sheet-names
  [{:keys [file survey-id]} on-success on-error]
  (let [wb (ex-workbook/create-workbook)
        xlsx (oops/oget wb "xlsx")
        load-promise (oops/ocall! xlsx "load" file)]
    (-> load-promise
        (.then
          (fn [_]
            (let [sheet-names (mapv #(oops/oget % "name") (oops/oget wb "worksheets"))
                  available-sheets (set sheet-names)
                  invest-europe-sheet "FILL THIS Invest Europe"
                  tesi-sheet-alternatives #{"FILL THIS Tesi specific"
                                            "FILL THIS FVCA & Tesi specific"}
                  has-required-sheets? (and (contains? available-sheets invest-europe-sheet)
                                            (some available-sheets tesi-sheet-alternatives))]
              (if has-required-sheets?
                (on-success survey-id file sheet-names)
                (on-error :missing-required-sheets)))))
        (.catch
          (fn [_e]
            (on-error :sheet-extraction-error))))))

(rf/reg-event-fx
  ::extract-sheet-names-ok
  (fn [{_db :db} [_ survey-id file _sheet-names]]
    {:fx [[:dispatch [::open-sheet-selector survey-id file]]]}))

(rf/reg-event-fx
  ::extract-sheet-names-failed
  (fn [{db :db} [_ survey-id error-reason]]
    (js/console.log "Parse failed " error-reason)
    {:db (-> db
             (assoc-in [::sub/missing-required-sheets? survey-id] true))}))

(rf/reg-event-fx
  ::validate-uploaded-excel
  (fn [{_db :db} [_ survey-id import-file]]
    (extract-sheet-names
      {:file      import-file
       :survey-id survey-id}
      (fn [survey-id file sheet-names]
        (rf/dispatch [::extract-sheet-names-ok survey-id file sheet-names]))
      (fn [error-reason]
        (rf/dispatch [::extract-sheet-names-failed survey-id error-reason])))
    {}))

(rf/reg-event-fx
  ::parse-ok
  (fn [{db :db} [_ survey-id parsed-data wb parse-errors]]
    {:db (-> db
             (assoc-in [::sub/unsaved-answer-series survey-id] parsed-data)
             (assoc-in [::sub/uploading? survey-id] false)
             (assoc-in [::sub/parsing-error? survey-id] (seq parse-errors))
             (assoc-in [::sub/data-import-error survey-id] :data-import-error-parse-errors)
             (assoc-in [::sub/error-workbook survey-id] wb)
             (assoc-in [::sub/cell-parse-errors survey-id] parse-errors))}))

(rf/reg-event-fx
  ::parse-failed
  (fn [{db :db} [_ survey-id error-reason]]
    {:db (-> db
             (assoc-in [::sub/uploading? survey-id] false)
             (assoc-in [::sub/parsing-error? survey-id] true)
             (assoc-in [::sub/data-import-error survey-id] error-reason)
             (assoc-in [::sub/cell-parse-errors survey-id] nil))}))

(rf/reg-event-fx
  ::extract-data
  (fn [{db :db} [_ survey-id import-file]]
    (let [lang (get db [::sub/selected-lang] :ENG)
          configuration (get-in db [::sub/configurations survey-id])
          questions (survey-helpers/resolve-indexed-questions configuration)
          row-configs (resolve-import-rows lang questions)]
      (extract-excel-data
        {:file        import-file
         :row-configs row-configs}
        (fn [parsed-data wb parse-errors]
          (rf/dispatch [::parse-ok survey-id parsed-data wb parse-errors]))
        (fn [error-reason]
          (rf/dispatch [::parse-failed survey-id error-reason])))
      {})))

(rf/reg-event-fx
  ::open-sheet-selector
  (fn [{db :db} [_ survey-id import-file]]
    (let [hardcoded-sheets [{:value "FILL THIS Invest Europe"
                             :label "FILL THIS Invest Europe"}
                            {:value "FILL THIS Tesi specific"
                             :label "FILL THIS Tesi specific"}]]
      {:db (->
             db
             (assoc-in [::sub/selected-import-file survey-id] import-file)
             (assoc-in [::sub/selected-sheets survey-id] ["FILL THIS Invest Europe"
                                                          "FILL THIS Tesi specific"])
             (assoc-in [::sub/selected-sheets-options survey-id] hardcoded-sheets)
             (assoc-in [::sub/selecting-sheets? survey-id] true))})))

(rf/reg-event-fx
  ::import-tesi-custom-excel
  (fn [{db :db} [_ survey-id]]
    (let [import-file (get-in db [::sub/selected-import-file survey-id])
          selected-sheets (get-in db [::sub/selected-sheets survey-id])]
      {:db (->
             db
             (assoc-in [::sub/selecting-sheets? survey-id] false)
             (assoc-in [::sub/uploading? survey-id] true)
             (assoc-in [::sub/parsing-error? survey-id] false)
             (assoc-in [::sub/data-import-error survey-id] nil))
       :fx [[:dispatch [::extract-data-tesi survey-id import-file selected-sheets]]]})))

(rf/reg-event-fx
  ::cleanup
  (fn [{db :db} _]
    {:db (-> db
             (dissoc ::sub/unconfirmed-parsed-data
                     ::sub/uploading?
                     ::sub/selecting-sheets?
                     ::sub/selected-import-file
                     ::sub/selected-sheets
                     ::sub/resolving-errors?
                     ::sub/import-data-confirmed?
                     ::sub/editing-error-cell?
                     ::sub/sheet-selection-confirmed?
                     ::sub/overwrite-answers-modal-open?
                     ::sub/parsing-error?
                     ::modal-sub/show-rows-without-errors?
                     ::modal-sub/show-columns-without-errors?
                     ::modal-sub/show-resolve-errors-warning?))}))

(rf/reg-event-fx
  ::import-excel
  (fn [{db :db} [_ survey-id import-file]]
    {:db (->
           db
           (assoc-in [::sub/uploading? survey-id] true)
           (assoc-in [::sub/parsing-error? survey-id] false)
           (assoc-in [::sub/data-import-error survey-id] nil)
           (assoc-in [::sub/cell-parse-errors survey-id] nil)
           (assoc-in [::sub/error-workbook survey-id] nil))
     :fx [[:dispatch [::extract-data survey-id import-file]]]}))

(rf/reg-event-fx
  ::download-error-file
  (fn [{db :db} [_ survey-id]]
    (let [error-wb (get-in db [::sub/error-workbook survey-id])
          configuration (get-in db [::sub/configurations survey-id])]
      (when error-wb
        (ex-workbook/save-workbook error-wb (get-in configuration [:label :ENG])))
      {:fx [[:dispatch [::clear-errors survey-id]]]})))

(rf/reg-event-fx
  ::clear-errors
  (fn [{db :db} [_ survey-id]]
    {:db (-> db
             (assoc-in [::sub/uploading? survey-id] false)
             (assoc-in [::sub/parsing-error? survey-id] false)
             (assoc-in [::sub/data-import-error survey-id] nil)
             (assoc-in [::sub/cell-parse-errors survey-id] nil)
             (assoc-in [::sub/error-workbook survey-id] nil))}))

(rf/reg-event-fx
  ::clear-errors-tesi
  (fn [{db :db} [_ survey-id]]
    {:db (-> db
             (assoc-in [::sub/uploading? survey-id] false)
             (assoc-in [::sub/tesi-custom-excel-import-failed? survey-id] false)
             (assoc-in [::sub/data-import-error survey-id] nil)
             (assoc-in [::sub/missing-required-sheets? survey-id] false))}))

(rf/reg-event-fx
  ::on-logout-ok
  (fn [{_db :db} [_]]
    (set! js/location.href "/")
    {}))

(rf/reg-event-fx
  ::on-logout-failed
  (fn [{_db :db} [_]]
    (js/console.log "Unimplemented on-logout-failed")
    {}))

(rf/reg-event-fx
  ::logout
  (fn [{_db :db} [_]]
    {:http-xhrio {:method          :post
                  :uri             "/login/api/logout"
                  :params          {}
                  :timeout         30000
                  :format          (ajax/transit-request-format)
                  :response-format (ajax/transit-response-format)
                  :on-success      [::on-logout-ok]
                  :on-failure      [::on-logout-failed]}}))
